import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button, ButtonPropsType } from 'components/Controls/Button';
import MoreVerticalSvg from './moreVertical.svg';

interface IconButtonPropsType extends ButtonPropsType {
  iconSize?: number;
}

export const MoreVerticalIcon = (props: any) => <Icon component={MoreVerticalSvg} {...props} />;

export const MoreVerticalIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonPropsType>(
  ({ size = 'medium', iconSize = 24, type = ButtonType.OutlineIcon, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<MoreVerticalSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
MoreVerticalIconButton.displayName = 'MoreVerticalIconButton';
